// import React from "react";

// const FILTERS = [
//   { value: "all", label: "All" },
//   { value: "active", label: "Active" },
//   { value: "pending", label: "Pending" },
//   { value: "disabled", label: "Disabled" },
// ];

// const UsersFilterBar = ({ viewMode, setViewMode }) => {
//   return (
//     <div className="flex flex-wrap">
//       {FILTERS.map((f) => (
//         <button
//           key={f.value}
//           type="button"
//           className={`ma1 bn br-pill ph3 pv2 pointer fw6 ${
//             viewMode === f.value ? "bg-gold black" : "bg-light-gray dark-gray"
//           }`}
//           onClick={() => setViewMode(f.value)}
//         >
//           {f.label}
//         </button>
//       ))}
//     </div>
//   );
// };

// export default UsersFilterBar;


// UsersFilterBar.js
// Same pill-button pattern as RecordsFilterBar so the Users page filters
// look and behave consistently with the Records page.

import React from "react";

const UsersFilterBar = ({ viewMode, setViewMode }) => {
  const filters = [
    { key: "all", label: "All Users", icon: "👥" },
    { key: "active", label: "Active", icon: "✅" },
    { key: "pending", label: "Pending", icon: "⏳" },
    { key: "disabled", label: "Disabled", icon: "⛔" },
    { key: "farmer", label: "Farmers", icon: "🌾" },
    { key: "clerk", label: "Clerks", icon: "🧾" },
  ];

  return (
    <div className="flex flex-wrap">
      {filters.map((filter) => (
        <button
          key={filter.key}
          onClick={() => setViewMode(filter.key)}
          className={`ma1 br-pill bn pointer ph3 pv2 fw6 transition-all ${
            viewMode === filter.key
              ? "bg-dark-blue white"
              : "bg-near-white dark-gray"
          }`}
        >
          <span className="mr1">{filter.icon}</span>
          {filter.label}
        </button>
      ))}
    </div>
  );
};

export default UsersFilterBar;